import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
// import "./Contact.css"
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/logo.svg";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";
import emailjs from 'emailjs-com';
import {FiGithub, FiMail, FiPhone} from "react-icons/fi";

export const Contact = () => {
  const formInitialDetails = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  }
  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState('Send');
  const [status, setStatus] = useState({});

  
  const SERVICE_ID = 'service_tu00xop'; // Replace with your EmailJS service ID
  const TEMPLATE_ID = 'template_36wbwls'; // Replace with your EmailJS template ID
  const USER_ID = '7d-UXlFL0BGi6HdWdC1-X'; // Replace with your EmailJS user ID


  const onFormUpdate = (category, value) => {
      setFormDetails({
        ...formDetails,
        [category]: value
      })
  }

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setButtonText("Sending...");
  //   let response = await fetch("http://localhost:5000/contact", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json;charset=utf-8",
  //     },
  //     body: JSON.stringify(formDetails),
  //   });
  //   setButtonText("Send");
  //   let result = await response.json();
  //   setFormDetails(formInitialDetails);
  //   if (result.code == 200) {
  //     setStatus({ succes: true, message: 'Message sent successfully'});
  //   } else {
  //     setStatus({ succes: false, message: 'Something went wrong, please try again later.'});
  //   }
  // };

  const navigateToLinkedIn = () => {
    window.location.href =
      "https://www.linkedin.com/in/vikassuresh5/";
  };

  const navigateToFacebook = () => {
    window.location.href =
      "https://www.facebook.com/vikas.suresh.3597";
  };

  const navigateToGithub = () => {
    window.location.href =
      "https://github.com/vikassuresh4397";
  };

  const navigateToInstagram = () => {
    window.location.href =
      "https://www.instagram.com/mephisto7991/";
  };

  const handleSubmit = (e) => {
    // e.preventDefault();
    // setButtonText('Sending...');

    // // Compose the email parameters
    // const emailParams = {
    //   firstName: formDetails.firstName,
    //   lastName: formDetails.lastName,
    //   email: formDetails.email,
    //   phone: formDetails.phone,
    //   message: formDetails.message,
    // };

    // // Send the email using EmailJS
    // emailjs.send(SERVICE_ID, TEMPLATE_ID, emailParams, USER_ID)
    //   .then((response) => {
    //     console.log('Email sent:', response);
    //     setButtonText('Send');
    //     setFormDetails(formInitialDetails);
    //     setStatus({ success: true, message: 'Message sent successfully' });
    //   })
    //   .catch((error) => {
    //     console.error('Error sending email:', error);
    //     setButtonText('Send');
    //     setStatus({ success: false, message: 'Something went wrong, please try again later.' });
    //   });
    setFormDetails(formInitialDetails)
  };

  return (
    <section className="contact" id="contact">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <img className={isVisible ? "animate__animated animate__zoomIn" : ""} src={contactImg} alt="Contact Us"/>
              }
            </TrackVisibility>
          </Col>
          <Col  size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div id="ddd" className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h2>Get In Touch</h2>
                <form onSubmit={handleSubmit} action="https://formsubmit.co/vikassuresh4397@gmail.com" method="POST">
                  <Row>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text"  placeholder="First Name" id="fullName" name="fullName" required />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" 
                      placeholder="Last Name"  id="lastName" name="lastName" required />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="email"  placeholder="Email Address"  id="email" name="email" required />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="phone" placeholder="Phone No."  id="phone" name="phone" required />
                    </Col>
                    <Col size={12} className="px-1">
                      <textarea rows="6"  placeholder="Message"  id="message" name="message" required ></textarea>
                      <button type="submit"><span>{buttonText}</span></button>
                    </Col>
                    {
                      status.message &&
                      <Col>
                        <p className={status.success === false ? "danger" : "success"}>{status.message}</p>
                      </Col>
                    }

                  </Row>
                </form>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      


     

 
  
    
       


    </section>
  )
}




